'use client';
import { useEffect } from 'react';

function AppVersion({ appVersion }: { appVersion: string }) {
  useEffect(() => {
    // eslint-disable-next-line no-console
    console.info(`### App Version: %c${appVersion} %c###`, 'font-weight: bold;color:#fc0', '');
  }, [appVersion]);

  return null;
}

export default AppVersion;
